<template>
	<span :class="[TYPE_BADGE_BASE, badge.pill]" :data-type="type === 'live' ? 'live' : 'video'">
		<span class="size-1.5 rounded-full" :class="badge.dot" aria-hidden="true" />
		{{ badge.label }}
	</span>
</template>

<script setup>
// Live / Video type pill. Classes come from analyticsTypeBadge.js so every
// place that shows the type renders exactly the same badge.
import { computed } from 'vue';
import { TYPE_BADGE_BASE, typeBadge } from './analyticsTypeBadge';

const props = defineProps({
	type: { type: String, default: 'vod' }, // 'live' | 'vod' | 'unknown'
});

const badge = computed(() => typeBadge(props.type));
</script>
